import { ChangeDetectorRef, Component } from "@angular/core";
import { NgFor, NgIf } from "@angular/common";
import { CptDetails } from "src/app/common/interfaces/cosign.interface";
import { ConfirmationModalComponent } from "src/app/common/components/core/modal/confirmation-modal/confirmation-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { CoSignerClient } from "src/app/common/services/co-signer.client";

@Component({
  selector: "app-billing-details",
  standalone: true,
  imports: [NgFor, NgIf],
  template: `
    <table border="1" class="billing-table">
      <thead>
        <tr>
          <th class="column-size">CPT</th>
         <th class="description-column">Description</th>
         <th class="column-size">Mins</th>
         <th class="column-size">Units</th>
         <th class="column-size">Action</th>
          
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of detailRowData">
          <td  class="column-size">{{ row.cptCode }}</td>
          <td class="description-column">{{ row.description }}</td>
          <td class="column-size">{{ row.mins }}</td>
          <td class="column-size">{{ row.units }}</td>
          <td class="column-size">
           <ng-container *ngIf="row.notes && row.notes.trim(); else noNotes">
            <a (click)="openPopup(row.notes)">View Notes</a>
           </ng-container>
           <ng-template #noNotes>--</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  `,
  styles: [
    `
      .billing-table {
        border-collapse: collapse;
        display: flex;
        flex-direction: column;
        text-align: center;
        padding: 10px 40px;
        justify-content: center;
        align-items: center;
        background-color: white;
      }

      .billing-table tbody {
        display: block;
        overflow-y: auto;
      }

      .billing-table thead,
      .billing-table tbody tr {
        display: table;
        width: 100%;
        height: 35px;
        table-layout: fixed;
        border: 1px solid rgba(0, 0, 0, 0.2);
      }

      .description-column {
        width: 40%;
        word-wrap: break-word; 
        overflow-wrap: break-word;
        white-space: normal; 
      }
      .column-size {
        width: 15%;
      }
    `,
  ],
})
export class BillingDetailsComponent {
  detailRowData: CptDetails[] = [];

  constructor(private cdr: ChangeDetectorRef, private dialog: MatDialog, private cosignClient:CoSignerClient) { }

  agInit(params: any): void {
    if(params.data){
      this.getCoSignBillingCPTdetails( params.data?.disciplineId, params.data?.patientId, params.data?.date, params.data?.requestedById)
    }
    this.cdr.detectChanges();
  }

  openPopup(note: string) {
    this.dialog.open(ConfirmationModalComponent, {
      data: {
        title: "Notes",
        message: note || "No Note available",
        hideCancelButton: true,
        buttonText: "Ok",
      },
    })
  }

  getCoSignBillingCPTdetails(disciplineId: number, patientId: string, date: Date, requestedById : string) {
    this.cosignClient.getCoSignBillingCPTdetails(disciplineId, patientId, date,requestedById).subscribe((data: any) => {
      this.detailRowData = data.responseData;
    })
  }
}
